import type { AppConfig } from '@plato/app-meta/app-config-type';
import { createContext } from 'react';

export const AppConfigContext = createContext<AppConfig | undefined>(undefined);
